import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API, { serviceApiUrl as ServiceQK, serviceCategoryApiUrl as CategoryQK } from 'src/pages/services/api/api';
import EducationAPI, { educationApiUrl as CoursesQK } from 'src/pages/courses/api/api';
import { ResponseType } from 'src/constants/data';

export const useGetCategories = () => {
  return useQuery({
    queryKey: [CategoryQK, ResponseType.List],
    queryFn: () => API.getCategories(),
    placeholderData: keepPreviousData
  });
};

export const useGetServiceBlock = (params: { search: string; categoryId: string }) => {
  return useQuery({
    queryKey: [ServiceQK, ResponseType.List, JSON.stringify(params)],
    queryFn: () => API.getServicesBlocks({ limit: 2, ...params }, 1),
    placeholderData: keepPreviousData,
    enabled: !!params.categoryId && params.search.length > 0
  });
};

export const useGetCourses = (params: { search: string }) => {
  return useQuery({
    queryKey: [CoursesQK, ResponseType.List, params],
    queryFn: () => EducationAPI.search(1, { limit: 3, ...params }),
    placeholderData: keepPreviousData,
    enabled: params.search.length > 0
  });
};
